import React from "react"
import { useNavigate } from "react-router-dom";

function App() {
  const navigate = useNavigate();
  const signupPage = () => {
    navigate("./Signup")
  }

  const loginPage = () => {
    navigate("./Login")
  }

  return (
      <div className="relative">
      <div className="py-5 px-4 flex justify-between items-center">
        <h2 className="font-bold text-lg">Objects-Des-9</h2>
        <div>
          <button
            type="button"
            className="font-roboto te w-24 h-8 bg-orange text-white rounded-[20px] mr-4"
            onClick={signupPage}
          >
            Sign Up
          </button>
          <button
            type="button"
            className="font-roboto w-24 h-8 bg-green text-white rounded-[20px]"
            onClick={loginPage}
          >
            Log In
          </button>
        </div>
      </div>
      <div className="bg-darkBlue min-h-[1000px] flex-row justify-center items-center 
                        bg-splash-pattern bg-clip-border bg-no-repeat bg-bottom bg-contain lg:bg-auto"
      >
        <h1 className="bg-darkBlue text-white font-semibold text-[62px] text-center leading-[72px] pt-[78px]">
          Georgia Tech
        </h1>
        <h1 className="bg-darkBlue text-green font-semibold text-[53px] text-center leading-[72px] -mt-4">
          Campus Discovery Portal
        </h1>
        <p className=" bg-darkBlue font-roboto text-gray text-[20px] text-center">
          Explore the Georgia Tech campus and join fascinating events!
        </p>
        <div className="bg-darkBlue flex justify-center items-center mt-[18px]">
          <button
            type="button"
            className="font-roboto font-bold w-[148px] h-[55px] bg-orange text-white rounded-[200px] mr-4"
            onClick={signupPage}
          >
            Sign Up
          </button>
          <button
            type="button"
            className="font-roboto font-bold w-[148px] h-[55px] bg-green text-white rounded-[200px]"
            onClick={loginPage}
          >
            Log In
          </button>
        </div>
      </div>

      <div className="flex items-center justify-between px-[82px] py-[15px]">
        <p className="font-roboto text-[#78868F] text-[13px]">
      Copyright © 2022, gatechcampusdiscovery.us
          </p>
        <div className="flex">
        <p className="font-roboto text-[#48575F] text-[14px] mr-4">Contact</p>
        <p className="font-roboto text-[#48575F] text-[14px] mr-8">Privacy</p>
      </div>
      </div>
      </div>
  );
}

export default App;